<template>
  <div class="list-head-date">
    <div class="date">
      <van-button round size="small" @click="showSelectDate">{{
        date
      }}</van-button>
    </div>
    <div class="action">
      <van-button
        icon="arrow-left"
        square
        round
        size="small"
        :disabled="prev"
        @click="prevDate()"
      />
      <van-button
        icon="arrow"
        square
        round
        size="small"
        style="margin-left:0.1rem;"
        :disabled="next"
        @click="nextDate()"
      />
    </div>
  </div>
</template>

<script>
import { Button } from "vant";
import { countDate, formatDate } from "@/utils/common";
import DateTimePicker from "@/components/date-time-picker/function";

export default {
  name: "ListHeadDatePicker",
  components: {
    [Button.name]: Button,
  },
  props: {
    date: {
      type: String,
      default: "",
    },
    minDate: {
      type: String,
      default: "1900-01-01",
    },
    maxDate: {
      type: String,
      default: formatDate(),
    },
  },
  model: {
    prop: "date",
    event: "update",
  },
  data() {
    return {
      // cpoyDate: ""
      prev: false,
      next: false,
    };
  },
  watch: {
    date() {
      this.setButton(this.date);
      this.$emit("change", this.date);
    },
  },
  created() {
    this.setButton();
  },
  methods: {
    showSelectDate() {
      DateTimePicker({
        value: this.date,
        format: "yyyy-MM-dd",
        minDate: this.minDate,
        maxDate: this.maxDate,
        change: this.setDate,
      });
    },
    setDate(date) {
      this.$emit("update", date);
    },
    prevDate() {
      const date = countDate(this.date, -1);
      this.$emit("update", date);
    },
    nextDate() {
      const date = countDate(this.date, +1);
      this.$emit("update", date);
    },
    setButton(date = this.date) {
      //上一天
      if (date === this.minDate) {
        this.prev = true;
      } else {
        this.prev = false;
      }
      if (date === this.maxDate) {
        this.next = true;
      } else {
        this.next = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.list-head-date {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  padding: 0.3rem;
  background: #f1f1f1;
  font-size: 0;
  .date {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
  }
}
</style>
